import { mergeWith, pick } from "lodash";

export class OrganizationEditModel {
    public static $inject: string[] = ["$log", "$q", "authService", "organizationService"];

    private resource;

    constructor(
        private $log: ng.ILogService,
        private $q: ng.IQService,
        private authService,
        private organizationService
    ) {}

    public init() {
        this.setResource();
    }

    public save(fields) {
        return this.organizationService
            .update(this.authService.organization.id, pick(this.resource, fields))
            .then(res => {
                this.$log.info("updating organization", res);
                this.merge(this.authService.organization, pick(res, fields));
                this.setResource();
            })
            .catch(error => {
                this.$log.error("error updating organization", error);
                return this.$q.reject(error);
            });
    }

    public reset(fields) {
        this.merge(this.resource, pick(angular.copy(this.authService.organization), fields));
    }

    public saveShipping(form: ng.IFormController, fields: string | string[]) {
        return this.organizationService
            .update(this.authService.organization.id, pick(this.resource, fields))
            .then(res => {
                this.$log.info("updating organization shipping", res);
                this.merge(this.authService.organization, pick(res, fields));
                this.setResource();
                form.$setPristine();
                this.$q.resolve();
            })
            .catch(error => {
                this.$log.error(`Error while saving organization shipping ${form.$name}`, error);
                return this.$q.reject(error);
            });
    }

    public resetShipping(form: ng.IFormController, fields: string | string[]) {
        if (form) {
            form.$setPristine();
        }
        this.merge(this.resource, pick(angular.copy(this.authService.organization), fields));
    }

    private merge(dest, sources) {
        mergeWith(dest, sources, (_, src) => (Array.isArray(src) ? src : undefined));
    }

    private setResource() {
        this.resource = angular.copy(this.authService.organization);
        this.resource.shipping = angular.copy(this.resource.shipping) || { shipping_methods: [] };
    }
}
